import Api from '@/services/Api'

export default {
    getAllGruposIntercos(){
        return Api().get('grupos-intercos')
    },
    getGrupoIntercoById(id){
        return Api().get('grupos-intercos/' + id)
    },
    createGrupoInterco(form) {
        return Api().post('grupos-intercos/create', form)
    },
    updateGrupoInterco(form) {
        return Api().put('grupos-intercos/update', form)
    },
    deleteGrupoInterco(id) {
        return Api().put('grupos-intercos/delete/' + id)
    },
    getCuentasPorGrupoInterco(idGrupo) {
        return Api().get('grupos-intercos/cuentas/' + idGrupo)
    },
    asignarCuentasAGrupo(form) {
        return Api().post('grupos-intercos/asignar-cuentas', form)
    },
    deleteGrupoIntercoCompleto(interco) {
        return Api().delete('grupos-intercos/completo/' + interco)
    },
    deleteGrupoIntercoPorCompania(interco, idCompania) {
        return Api().delete('grupos-intercos/' + interco + '/compania/' + idCompania)
    }
}